// @flow
import React, { Fragment } from 'react';
import classnames from 'classnames';
import { get } from 'lodash';

import { type Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';
import {
  TextSeeMore,
  type TextSeeMoreProps,
} from 'Components/frameworks/text-see-more/TextSeeMore.jsx';

import * as CARD_LAYOUTS from 'Components/frameworks/card/Card.constants';
import { cardBodyThemes } from './CardBody.themes';

type Props = {
  color?: Colors,
  ctaLabel?: string,
  isTablet?: boolean,
  layout?: $Keys<typeof CARD_LAYOUTS>,
  link?: DynamicLinkProps,
  seeLessLabel?: string,
  seeMoreLabel?: string,
  text?: TextSeeMoreProps,
  theme?: string,
};

export function CardBody(props: Props) {
  const {
    color,
    ctaLabel,
    isTablet,
    layout,
    link = {},
    seeLessLabel,
    seeMoreLabel,
    text = {},
    theme = 'default',
  } = props;
  const { thCta, thCtaDefaultColor, thText } = cardBodyThemes[theme];

  const shouldBeCollapsable =
    !isTablet ||
    [CARD_LAYOUTS.COLUMN_1, CARD_LAYOUTS.COLUMN_2, CARD_LAYOUTS.COLUMN_3].indexOf(layout) !== -1;

  return (
    <Fragment>
      <TextSeeMore
        {...text}
        isCollapseEnabled={shouldBeCollapsable}
        hasNoScrollOnCollapse
        className={thText}
        seeLessLabel={seeLessLabel}
        seeMoreLabel={seeMoreLabel}
      />
      <TextLink
        {...link}
        className={classnames(thCta, { 'mt-5': get(text, 'text') })}
        color={color || thCtaDefaultColor}
        label={ctaLabel}
      />
    </Fragment>
  );
}
